interface PitchMetric {
  title: string
  value: string | number
}

interface PitchMetricsRowProps {
  metrics: PitchMetric[]
}

export function PitchMetricsRow({ metrics }: PitchMetricsRowProps) {
  // Reserve a fixed two-line slot regardless of whether anything's
  // selected — the pitch below needs a stable top edge, otherwise
  // clicking a throw nudges the entire pitch vertically.
  if (metrics.length === 0) {
    return <div aria-hidden className='h-[3.25rem]' />
  }

  return (
    <div className='flex h-[3.25rem] flex-wrap items-center gap-x-4 gap-y-2 overflow-hidden text-sm'>
      {metrics.map((m, i) => (
        <div key={`${m.title}-${i}`} className='flex items-center gap-4'>
          <div className='flex items-center gap-2 whitespace-nowrap'>
            <span className='text-muted-foreground'>{m.title}</span>
            <span className='text-foreground font-semibold tabular-nums'>
              {m.value}
            </span>
          </div>
          {i < metrics.length - 1 && (
            <span className='bg-border h-5 w-px shrink-0' aria-hidden />
          )}
        </div>
      ))}
    </div>
  )
}
